<template>
  <v-overlay :value="true">
    <v-progress-circular indeterminate color="primary"></v-progress-circular>
    <div class="text-center mt-3">Application is being updated, please try again later...</div>
  </v-overlay>
</template>

<script>
export default {
  name: 'AppUpdateOverlay',
};
</script>

<style>
.v-overlay__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  color: white;
}
</style>
